import { PG_DASHBOARD_SUMMARY_PATH, PRODUCT } from 'utils/constants';

import ipgImage from 'images/icons/ipg.svg';
import paymentGatewayImage from '../../images/icons/payment-gateway.svg';
import payoutsImage from '../../images/icons/payouts.svg';
import verificationSuiteImage from '../../images/icons/verification-suite.svg';
import softPOSImage from '../../images/icons/softPOS.svg';
import easySplitImage from '../../images/icons/easy-split.svg';
import ecom360LandingImage from '../../images/ecom360/ecom-landing-image.svg';
import baasImage from '../../images/icons/baas.svg';
import crossBorderImage from '../../images/icons/crossborder.svg';
import lendingGatewayImage from '../../images/icons/lending.svg';
import globalCollectionsImage from '../../images/icons/global-collections.svg';
import cashgramImage from '../../images/icons/cashgram.svg';
import paymentLinksImage from '../../images/icons/payment-links.svg';
import paymentFormsImage from '../../images/icons/payment-forms.svg';
import subscriptionImage from '../../images/icons/subscription.svg';
import bharatBillPayImage from '../../images/icons/bharat-bill-pay-service.svg';
import softposImage from '../../images/softPOS-Logo.svg';
import flowWiseImage from '../../images/icons/flowWise.svg';
import pgRiskShieldImage from '../../images/icons/pg-risk-shield.svg';
import payoutsRiskShieldImage from '../../images/icons/payouts-risk-shield.svg';
import workflowBuilderImage from '../../images/icons/relay-product.svg';
import { REG_KEYS } from 'constants/enums';
import { UPSERT_MERCHANT_REG_DETAILS_URL } from 'constants/url';

export const BASE_ACTION_CONSTANT = 'app/LandingPage';

export const GET_SUBSCRIPTION_STATUS = `${BASE_ACTION_CONSTANT}/GET_SUBSCRIPTION_STATUS`;
export const UPDATE_SUBSCRIPTION_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_SUBSCRIPTION_STATUS`;

export const FETCH_PRODUCT_STATUS = `${BASE_ACTION_CONSTANT}/FETCH_PRODUCT_STATUS`;
export const FETCH_PRODUCT_STATUS_SUCCESS = `${BASE_ACTION_CONSTANT}/FETCH_PRODUCT_STATUS_SUCCESS`;

export const FETCH_QUICK_LINKS = `${BASE_ACTION_CONSTANT}/FETCH_QUICK_LINKS`;
export const FETCH_QUICK_LINKS_SUCCESS = `${BASE_ACTION_CONSTANT}/FETCH_QUICK_LINKS_SUCCESS`;

export const FETCH_TEST_TOKEN_FROM_PROD = `${BASE_ACTION_CONSTANT}/FETCH_TEST_TOKEN_FROM_PROD`;
export const FETCH_TEST_TOKEN_FROM_PROD_SUCCESS = `${BASE_ACTION_CONSTANT}/FETCH_TEST_TOKEN_FROM_PROD_SUCCESS`;

export const RESEND_EMAIL_VERIFICATION = `${BASE_ACTION_CONSTANT}/RESEND_EMAIL_VERIFICATION`;
export const RESEND_EMAIL_VERIFICATION_SUCCESS = `${BASE_ACTION_CONSTANT}/RESEND_EMAIL_VERIFICATION_SUCCESS`;

export const REQUEST_PRODUCT_ACTIVATION = `${BASE_ACTION_CONSTANT}/REQUEST_PRODUCT_ACTIVATION`;

export const VALIDATE_TOKEN = `${BASE_ACTION_CONSTANT}/VALIDATE_TOKEN`;
export const VALIDATE_TOKEN_SUCCESS = `${BASE_ACTION_CONSTANT}/VALIDATE_TOKEN_SUCCESS`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;
export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const FRESHDESK_REDIRECT = `${BASE_ACTION_CONSTANT}/FRESHDESK_REDIRECT`;
export const FETCH_HELPCENTER_FORM = `${BASE_ACTION_CONSTANT}/FETCH_HELPCENTER_FORM`;
export const FETCH_HELPCENTER_FORM_SUCCESS = `${BASE_ACTION_CONSTANT}/FETCH_HELPCENTER_FORM_SUCCESS`;
export const FETCH_HC_FORM_DATA_SUCCESS = `${BASE_ACTION_CONSTANT}/FETCH_HC_FORM_DATA_SUCCESS`;
export const OPEN_HC_FORM = `${BASE_ACTION_CONSTANT}/OPEN_HC_FORM`;
export const CLOSE_HC_FORM = `${BASE_ACTION_CONSTANT}/CLOSE_HC_FORM`;
export const CLOSE_BANNER = `${BASE_ACTION_CONSTANT}/CLOSE_BANNER`;
export const PAYOUT_PROTECT_INSIGHTS = `${BASE_ACTION_CONSTANT}/PAYOUT_PROTECT_INSIGHTS`;
export const PAYOUT_PROTECT_ACTIVE_STATUS = `${BASE_ACTION_CONSTANT}/PAYOUT_PROTECT_ACTIVE_STATUS`;
export const ACTIVATE_PAYOUT_PROTECT = `${BASE_ACTION_CONSTANT}/ACTIVATE_PAYOUT_PROTECT`;
export const ACTIVATE_RISKSHIELD = `${BASE_ACTION_CONSTANT}/ACTIVATE_RISKSHIELD`;
export const PAYOUT_PROTECT_INSIGHTS_SUCCESS = `${BASE_ACTION_CONSTANT}/PAYOUT_PROTECT_INSIGHTS_SUCCESS`;
export const PAYOUT_PROTECT_ACTIVE_STATUS_SUCCESS = `${BASE_ACTION_CONSTANT}/PAYOUT_PROTECT_ACTIVE_STATUS_SUCCESS`;
export const RISK_SHIELD_ACTIVE_STATUS = `${BASE_ACTION_CONSTANT}/RISK_SHIELD_ACTIVE_STATUS`;
export const RISK_SHIELD_ACTIVE_STATUS_SUCCESS = `${BASE_ACTION_CONSTANT}/RISK_SHIELD_ACTIVE_STATUS_SUCCESS`;
export const FEATURE_REQUEST_STATUS = `${BASE_ACTION_CONSTANT}/FEATURE_REQUEST_STATUS`;

export const FETCH_SSO_FEATURE_TOGGLE = `${BASE_ACTION_CONSTANT}/FETCH_SSO_FEATURE_TOGGLE`;
export const FETCH_SSO_FEATURE_TOGGLE_SUCCESS = `${BASE_ACTION_CONSTANT}/FETCH_SSO_FEATURE_TOGGLE_SUCCESS`;

export const FETCH_KYC_UPDATE_MODAL = `${BASE_ACTION_CONSTANT}/FETCH_KYC_UPDATE_MODAL`;
export const FETCH_KYC_UPDATE_MODAL_SUCCESS = `${BASE_ACTION_CONSTANT}/FETCH_KYC_UPDATE_MODAL_SUCCESS`;

// product review statuses
export const UNDER_REVIEW = 'UNDER_REVIEW';
export const CANCELLED = 'CANCELLED';
export const APPROVED = 'APPROVED';
export const THANK_YOU = 'thank-you';

// Check merchant config
export const CHECK_MERCHANT_CONFIG = `${BASE_ACTION_CONSTANT}/CHECK_MERCHANT_CONFIG`;

// Fetch Gamma Token
export const FETCH_GAMMA_TOKEN = `${BASE_ACTION_CONSTANT}/FETCH_GAMMA_TOKEN`;

export const UPDATE_GAMMA_TOKEN = `${BASE_ACTION_CONSTANT}/UPDATE_GAMMA_TOKEN`;

export const FETCH_PAYOUT_DASHBOARD_CONFIG = `${BASE_ACTION_CONSTANT}/FETCH_PAYOUT_DASHBOARD_CONFIG`;
export const FETCH_PAYOUT_DASHBOARD_CONFIG_SUCCESS = `${BASE_ACTION_CONSTANT}/FETCH_PAYOUT_DASHBOARD_CONFIG_SUCCESS`;

export const REDEEM_VOUCHER = `${BASE_ACTION_CONSTANT}/REDEEM_VOUCHER`;
export const SUBSCRIBE_WHATSAPP = `${BASE_ACTION_CONSTANT}/SUBSCRIBE_WHATSAPP`;
export const WHATSAPP_CONSENT = `${BASE_ACTION_CONSTANT}/WHATSAPP_CONSENT`;

export const PARTNER_CONSENT = `${BASE_ACTION_CONSTANT}/PARTNER_CONSENT`;
export const PARTNER_TNC = `${BASE_ACTION_CONSTANT}/PARTNER_TNC`;

export const FETCH_BANNERS = `${BASE_ACTION_CONSTANT}/FETCH_BANNERS`;
export const FETCH_PRODUCT_CARDS = `${BASE_ACTION_CONSTANT}/FETCH_PRODUCT_CARDS`;
export const QUICK_ACTIVATE_PRODUCT = `${BASE_ACTION_CONSTANT}/QUICK_ACTIVATE_PRODUCT`;
export const ACTIVATE_PRODUCTS = `${BASE_ACTION_CONSTANT}/ACTIVATE_PRODUCTS`;

export const GET_MERCHANT_DETAILS = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_DETAILS`;
export const GET_ACCOUNT_MANAGER_DETAILS = `${BASE_ACTION_CONSTANT}/GET_ACCOUNT_MANAGER_DETAILS`;
export const SET_ACCOUNT_MANAGER_DETAILS = `${BASE_ACTION_CONSTANT}/SET_ACCOUNT_MANAGER_DETAILS`;
export const ACTIVATE_ECOM_PRODUCT_ACTION = `${BASE_ACTION_CONSTANT}/ACTIVATE_ECOM_PRODUCT_ACTION`;

export const FETCH_AGGREGATED_PRODUCT_STATUS = `${BASE_ACTION_CONSTANT}/FETCH_AGGREGATED_PRODUCT_STATUS`;

export const FETCH_BANNERS_URL = {
  url: '/common/onboardingsvc/banner',
  method: 'GET',
};

export const FETCH_PRODUCT_CARDS_URL = {
  url: '/common/onboardingsvc/product-card',
  method: 'GET',
};

export const QUICK_ACTIVATE_PRODUCT_URL = {
  url: '/common/onboardingsvc/product/$productName$/quick-activate',
  method: 'POST',
};

export const ACTIVATE_PRODUCTS_URL = {
  url: '/common/onboardingsvc/merchant/product-preferences',
  method: 'POST',
};

export const PARTNER_CONSENT_URL = {
  url: '/common/partner/terms',
  method: 'GET',
};

export const PARTNER_TNC_URL = {
  url: '/common/partner/consent',
  method: 'PATCH',
};

export const AM_DETAILS_URL = {
  url: '/common/team-members/$merchantId$',
  method: 'GET',
};

export const PRODUCT_ACTIVATE_URL = {
  url: '/pg/product/activate',
  method: 'POST',
};

export const LIVE_PRODUCT_STATUS_URL = {
  url: '/common/dashboard/product-status',
  method: 'GET',
};

export const PAYOUT_PROTECT_INSIGHTS_URL = {
  url: '/merchant/v1/risk-platform/po/insights/aggregated-data',
  method: 'GET',
};

export const FEATURE_TOGGLE_URL = {
  url: '/ob/merchant/configs/feature-toggle',
  method: 'GET',
};

export const PAYOUT_PROTECT_ACTIVE_STATUS_URL = {
  url: '/merchant/v1/risk-platform/product/PO/status',
  method: 'GET',
};

export const ACTIVATE_PAYOUT_PROTECT_URL = {
  url: '/merchant/v1/risk-platform/screening-flags/activate/all?product=PO',
  method: 'POST',
};

export const ACTIVATE_RISKSHIELD_URL = {
  url: '/merchant/v1/risk-platform/screening-flags/activate/all?product=PG&activationSource=RISK_SHIELD_PAGE',
  method: 'POST',
};

export const RISK_SHIELD_ACTIVE_STATUS_URL = {
  url: '/merchant/v1/risk-platform/product/PG/status',
  method: 'GET',
};

export const FEATURE_REQUEST_STATUS_URL = {
  url: '/common/feature/status-count',
  method: 'GET',
};

export const OB_MODALS_URL = {
  url: '/modals',
  method: 'GET',
};

export const PRODUCT_CONFIG_MAPPING = {
  Ecom360: {
    pathname: 'pg/one-click-checkout',
  },
  PG: {
    pathname: PG_DASHBOARD_SUMMARY_PATH,
    // configName: 'pg_dashboard_new',
  },
  IPG: {
    pathname: PG_DASHBOARD_SUMMARY_PATH,
  },
  CSP: {
    pathname: 'payout',
    // configName: 'csp_dashboard_new',
  },
  CES: {
    pathname: 'pg/easy-split',
    // configName: 'pg_dashboard_new',
    hash: '/vendors',
  },
  ORDERS: {
    pathname: 'pg/payment-links',
    // configName: 'pg_dashboard_new',
    hash: '/all',
  },
  PF: {
    pathname: 'pg/payment-forms',
    // configName: 'pg_dashboard_new',
    hash: '/all',
  },
  PB: {
    pathname: 'pg/payment-buttons',
    // configName: 'pg_dashboard_new',
  },
  SBC: {
    pathname: 'pg/subscriptions',
    // configName: 'pg_dashboard_new',
  },
  EPOS: {
    pathname: 'pg/softpos',
    // configName: 'pg_dashboard_new',
  },
  PGRS: {
    pathname: 'pg/risk-shield/overview',
  },
};

export const PAYOUTS_PRODUCT_GROUP = ['CSP', 'CG'];
export const VERIFICATION_SUITE = 'VRS';
export const BBPS = 'BBPS';
export const BBPS_COU = 'BBPS_COU';
export const GCL = 'GCL';
export const BAAS = 'BAAS';
export const LAAS = 'LAAS';

export const LRS = 'LRS';
export const CAC = 'CAC';
export const PG = 'PG';
export const ECOM360 = 'Ecom360';
export const ECOM360_PRODUCT = 'ECOM360';
const EPOS = 'EPOS';
const CES = 'CES';
const CSP = 'CSP';
const VRS = 'VRS';
const CG = 'CG';
const ORDERS = 'ORDERS';
const PF = 'PF';
const PB = 'PB';
const IPG = 'IPG';
const ROUTER = 'ROUTER';

export const PG_RISKSHIELD = 'PGRS';
export const PO_RISKSHIELD = 'PORS';
export const WORKFLOW_BUILDER = 'WORKFLOW_BUILDER';

export const PRODUCT_MAPPING = {
  PG: 'Payment Gateway',
  PO: 'Payouts',
};

export const REDEEM_VOUCHER_MODAL = 'REDEEM_VOUCHER_MODAL';
export const CONGRATULATIONS = 'CONGRATULATIONS';

export const SUBSCRIBE_WHATSAPP_MODAL = 'SUBSCRIBE_WHATSAPP_MODAL';
export const SBC = 'SBC';
export const SUBS = 'SUBS';

export const MIN_KYC_PENDING = 'MIN_KYC_PENDING';
export const MIN_KYC_SUBMITTED = 'MIN_KYC_SUBMITTED';
export const MIN_KYC_APPROVED = 'MIN_KYC_APPROVED';
export const FULL_KYC_PENDING = 'FULL_KYC_PENDING';
export const FULL_KYC_SUBMITTED = 'FULL_KYC_SUBMITTED';
export const FULL_KYC_APPROVED = 'FULL_KYC_APPROVED';
export const MIN_KYC_REJECTED = 'MIN_KYC_REJECTED';
export const FULL_KYC_REJECTED = 'FULL_KYC_REJECTED';

export const LANDING_MODAL_CARDS = [
  // {
  //   type: 'voucher',
  //   desc1: 'Do you have any coupons?',
  //   desc2: 'Redeem it now to get free credits.',
  //   buttonText: 'Redeem',
  // },
  {
    type: 'whatsapp',
    desc1: 'Subscribe to receive important',
    desc2: 'updates on your WhatsApp',
    buttonText: 'Subscribe',
  },
];

export const BANNERS = {
  ALERT: 'ALERT',
  FOCUS: 'FOCUS',
  INTEGRATION: 'integration',
  RANGE: 'range',
  AUTO_ACTIVATION: 'autoActivation',
  V6: 'v6',
  V7: 'v7',
  OB_FEE: 'obFee',
};

export const bannerProductsMapping = {
  [PG]: {
    displayName: 'Payment Gateway',
    image: paymentGatewayImage,
  },
  [EPOS]: {
    displayName: 'softPOS',
    image: softPOSImage,
  },
  [CES]: {
    displayName: 'Easy Split',
    image: easySplitImage,
  },
  [SBC]: {
    displayName: 'Subscriptions',
    image: subscriptionImage,
  },
  [CSP]: {
    displayName: 'Payouts',
    image: payoutsImage,
  },
  [VRS]: {
    displayName: 'Secure ID',
    image: verificationSuiteImage,
  },
  [BAAS]: {
    displayName: 'BaaS',
    image: baasImage,
  },
  [GCL]: {
    displayName: 'Global Collections',
    image: globalCollectionsImage,
  },
  [LAAS]: {
    displayName: 'Lending Gateway',
    image: lendingGatewayImage,
  },
  // [LRS]: {
  //   displayName: 'Cross Border',
  //   image: crossBorderImage,
  // },
  [BBPS]: {
    displayName: 'BBPS - Biller',
    image: bharatBillPayImage,
  },
  [BBPS_COU]: {
    displayName: 'BBPS - COU',
    image: bharatBillPayImage,
  },
  [IPG]: {
    displayName: 'International Payment Gateway',
    image: ipgImage,
  },
  [ROUTER]: {
    displayName: 'FlowWise',
    image: flowWiseImage,
  },
  [PG_RISKSHIELD]: {
    displayName: 'Payment Gateway RiskShield',
    image: pgRiskShieldImage,
  },
  [PO_RISKSHIELD]: {
    displayName: 'Payouts Protect',
    image: payoutsRiskShieldImage,
  },
  [ECOM360_PRODUCT]: {
    displayName: 'One Click Checkout',
    image: ecom360LandingImage,
  },
};

export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';
export const EMAIL_VERIFICATION_REQUIRED = 'EMAIL_VERIFICATION_REQUIRED';

export const CRAWLER_FAILURE_BANNER =
  'MIN_KYC_BLOCKED_IN_ELIGIBLE_WEBSITE_CRAWLING_FAILED';

export const PRODUCT_CTA = {
  ACCESS: 'Access',
  REQUEST_ACTIVATION: 'Request Activation',
  COMPLETE_ACTIVATION: 'Complete Activation',
  QUICK_ACTIVATE: 'Quick Activate',
  ACTIVATION_IN_PROCESS: 'Activation in Process',
  REJECTED: 'Rejected',
  TRY_TEST: 'Try Test Environment',
  RESUBMIT_DOC: 'Resubmit Documents',
  EXPLORE_WITH_FREE_TRIAL: 'Explore with Free Trial',
};

export const productMapping = {
  [PRODUCT.ECOM360]: {
    id: ECOM360,
    image: ecom360LandingImage,
  },
  [PRODUCT.PAYMENT_GATEWAY]: {
    id: PG,
    image: paymentGatewayImage,
  },
  [PRODUCT.PAYOUT]: {
    id: CSP,
    image: payoutsImage,
  },
  [PRODUCT.SUBSCRIPTION]: {
    id: SBC,
    image: subscriptionImage,
  },
  [PRODUCT.VERIFICATION_SUITES]: {
    id: VRS,
    image: verificationSuiteImage,
  },
  [PRODUCT.CASHGRAM]: {
    id: CG,
    image: cashgramImage,
  },
  [PRODUCT.BANKING_AS_SERVICE]: {
    id: BAAS,
    image: baasImage,
  },
  [PRODUCT.PAYMENT_LINK]: {
    id: ORDERS,
    image: paymentLinksImage,
  },
  [PRODUCT.PAYMENT_FORM]: {
    id: PF,
    image: paymentFormsImage,
  },
  [PRODUCT.PAYMENT_BUTTON]: {
    id: PB,
    image: paymentFormsImage,
  },
  [PRODUCT.CROSS_BORDER]: {
    id: LRS,
    image: crossBorderImage,
  },
  [PRODUCT.LENDING_AS_SERVICE]: {
    id: LAAS,
    image: lendingGatewayImage,
  },
  [PRODUCT.GLOBAL_COLLECTION]: {
    id: GCL,
    image: globalCollectionsImage,
  },
  [PRODUCT.BILLER]: {
    id: BBPS,
    image: bharatBillPayImage,
  },
  [PRODUCT.BBPS_COU]: {
    id: BBPS_COU,
    image: bharatBillPayImage,
  },
  [PRODUCT.SOFT_POS]: {
    id: EPOS,
    image: softposImage,
  },
  [PRODUCT.IPG]: {
    id: IPG,
    image: ipgImage,
  },
  [PRODUCT.ROUTER]: {
    id: ROUTER,
    image: flowWiseImage,
  },
  [PRODUCT.PG_RISKSHIELD]: {
    id: PG_RISKSHIELD,
    image: pgRiskShieldImage,
  },
  [PRODUCT.PO_RISKSHIELD]: {
    id: PO_RISKSHIELD,
    image: payoutsRiskShieldImage,
  },
  [WORKFLOW_BUILDER]: {
    id: WORKFLOW_BUILDER,
    image: workflowBuilderImage,
  },
};

export const REQUEST_ACTIVATION_MODAL = 'REQUEST_ACTIVATION_MODAL';

export const STATUS_PAGE_LINK = 'https://statuspage.cashfree.com/';

export const accountManagerSortingOrder = {
  'Account Manager': 1,
  'Relationship Manager': 2,
  'PG Account Manager': 3,
  'PO Account Manager': 4,
  'VRS Account Manager': 5,
  'Subscription Account Manager': 6,
  'CrossBorder Account Manager': 7,
  'Partner Account Manager': 8,
  'Partner SalesOps Account Manager': 9,
  default: 10,
};

export const ECOM_DOC_LINK = 'https://ecom360.club/';
export const SYSTEM_STATUS = {
  UP: 'UP',
  DEGRADED: 'DEGRADED',
  DOWN: 'DOWN',
  LOADING: 'LOADING',
};

export const INSIGHTS_AI_MODAL_META_DATA = [
  {
    text: 'Success Rate',
    icon: 'BAR_GRAPH',
  },
  {
    text: 'Transaction Charges',
    icon: 'RUPEE',
  },
  {
    text: 'Payments, Settlements, Refunds & more',
    icon: 'PAYMENTS',
  },
  {
    subText: 'Generative AI',
    text: 'Insights',
    icon: 'STARS',
  },
];

export const OPEN_HC_FORM_FROM_URL = {
  param: 'raise_issue',
  value: '1',
};

export const OPEN_TICKET_HISTORY_PARAMS = {
  param: 'ticket-history',
  value: 'true',
};

export const DASHBOARD = 'DASHBOARD';

export const DISPLAY_INSIGHTS_AI_POPUP_THRESHOLD_COUNT = 5;

export const LANDING_PAGE_MODAL = {
  AGREEMENT_SENT: 'AGREEMENT_SENT',
  WEBSITE_CONFIRM_MODAL: 'WEBSITE_CONFIRM_MODAL',
  EMPTY_ALERT_EMAIL_MODAL: 'EMPTY_ALERT_EMAIL_MODAL',
  INSIGHTS_AI_MODAL: 'INSIGHTS_AI_MODAL',
  SHOW_TNC: 'SHOW_TNC',
  REFLECT_2025: 'REFLECT_2025',
  PAYMENT_LIMIT_MODAL: 'PAYMENT_LIMIT_MODAL',
  ADDRESS_UPDATE: 'ADDRESS_UPDATE',
  VERIFY_GST: 'VERIFY_GST',
  MORE_DETAILS: 'MORE_DETAILS',
  PAYOUT_PROTECT_MODAL: 'PAYOUT_PROTECT_MODAL',
};

export const MANAGER_ROLE_TO_PRODUCT_CODE_MAP = {
  'PG Account Manager': 'PG',
};

export const TARGET_TITLES_FOR_IMPORT = ['Payment Gateway', 'Subscriptions'];

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const MIN_SMART_RULE_COUNT_FOR_RISKSHIELD_WIDGET = 2;

export const CKYC_ACK = 'ckycAck';

// All banner types that render as BannerWithPopup — add new types here
export const POPUP_BANNER_TYPES = [CKYC_ACK];

export const FIELD_FORMAT_MAPPER = {
  [REG_KEYS.CKYC_CONSENT_STATUS]: [UPSERT_MERCHANT_REG_DETAILS_URL],
  [REG_KEYS.KYC_MIGRATION_MODAL_CLICKED]: [UPSERT_MERCHANT_REG_DETAILS_URL],
};

// Hardcoded frontend copy for popup banners — keyed by banner type
export const POPUP_BANNER_CONTENT = {
  [CKYC_ACK]: {
    secondaryCta: 'Why this?',
    popup: {
      title: 'Why do we need your CKYC records?',
      description: [
        'RBI updated its KYC guidelines in 2025. All regulated payment partners, including Cashfree, must bring existing merchants in line with the new KYC version.',
        "We've tried to make this as light as possible. Most businesses already have their KYC on CERSAI, the government-authorized central KYC registry. With your one-time consent, we fetch directly from there -- no documents, no forms.",
      ],
      consentingTo: {
        heading: "What you're consenting to:",
        points: [
          'One-time permission for Cashfree to fetch your records from CERSAI',
          'No data shared outside Cashfree',
          'No impact on your transactions or settlements',
        ],
      },
      afterConsent: {
        heading: 'What happens after you click "Give consent":',
        text: 'We fetch your records in the background and only reach out if anything more is needed from you.',
      },
      cersaiFallback: {
        heading: "If CERSAI fetch isn't available:",
        text: "We'll follow up with a simple document upload request as a fallback",
      },
      noConsent: {
        heading: "If you don't consent:",
        points: [
          'No immediate impact on transactions',
          "We'll reach out separately with next steps",
        ],
      },
      primaryCta: 'Give consent',
      secondaryCta: 'Close',
    },
    toast: {
      success:
        "We're on it. Fetching your KYC records from CERSAI -- we'll only reach out if something more is needed.",
      error: 'Something went wrong. Please try again in a moment.',
    },
  },
};
